import { SvgEnSavoir } from "./svg"

type LinkButtonProps = {
  onClick?: any,
  title: string,
  icon?: React.ReactNode,
  gap?: number,
  disabled?: boolean,
  style?: React.CSSProperties,
  textStyle?: React.CSSProperties,
  hideIcon?: boolean,
}

export const LinkButton = (props: LinkButtonProps) => {

  return (
    <a
      href="#"
      data-type="group"
      data-width="auto"
      data-gap={props.gap || 5}
      data-interactive="highlight"
      aria-disabled={props.disabled || undefined}
      tabIndex={props.disabled ? -1 : undefined}
      style={props.style}
      onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        if (!props.disabled) props.onClick?.(event);
      }}
    >
      {!props.hideIcon && <icon data-svg-color="secondary" data-color="secondary" data-size="20" data-svg-size="20">
        {props.icon ? props.icon : <SvgEnSavoir />}
      </icon>}
      <text data-text-size="medium" data-ellipsis="" data-color="secondary" style={props.textStyle}>
        {props.title}
      </text>
    </a>
  )
}